var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import clsx from 'clsx';
import React, { forwardRef, memo, } from 'react';
import { styled, withDeprecatedCheck, useThemeProps, } from '../../foundation';
import { RcCircularProgress } from '../Progress';
import { IconStyle, StyledSvg } from './styles';
import { RcIconSizes } from './utils';
import { useIconService } from './utils/IconService';
/**
 * * this is a component alway have same props,
 * * that just for render a icon, so here we can memo that
 */
var _RcIcon = memo(forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcIcon' });
    var loadingSize = props.loadingSize, useLoading = props.useLoading, iconColor = props.iconColor, iconSize = props.iconSize, icon = props.icon, desc = props.desc, className = props.className, _a = props.loading, loading = _a === void 0 ? useLoading : _a, CircularProgressProps = props.CircularProgressProps, symbol = props.symbol, children = props.children, 
    // * pick props
    color = props.color, size = props.size, rest = __rest(props, ["loadingSize", "useLoading", "iconColor", "iconSize", "icon", "desc", "className", "loading", "CircularProgressProps", "symbol", "children", "color", "size"]);
    var _b = useIconService().iconMap, iconMap = _b === void 0 ? {} : _b;
    var href = '';
    var Icon = null;
    var iconName = '';
    var renderDom;
    if (symbol) {
        if (typeof symbol === 'object' && symbol.id) {
            href = "#" + symbol.id;
            iconName = "" + symbol.id;
        }
        else {
            Icon = symbol;
            renderDom = React.createElement(Icon, null);
            iconName = symbol['iconName'];
        }
        // TODO: this will be remove when all using svg
    }
    else if (typeof children === 'string' || icon) {
        var childrenIconKey = (children && children.toString()) || icon || '';
        Icon = iconMap[childrenIconKey];
        iconName = childrenIconKey;
        if (Icon) {
            renderDom = React.createElement(Icon, null);
        }
    }
    else {
        renderDom = children;
    }
    var _className = clsx(className, iconName, 'icon');
    if (loading) {
        var progressSize = RcIconSizes[size];
        return (React.createElement(RcCircularProgress
        // TODO: here will be remove when loadingSize remove
        , __assign({ 
            // TODO: here will be remove when loadingSize remove
            size: loadingSize || typeof progressSize === 'string'
                ? '1em' // default size as 16px
                : progressSize, ref: ref }, CircularProgressProps)));
    }
    return (React.createElement("span", __assign({ className: _className }, rest, { ref: ref }),
        renderDom && React.createElement(StyledSvg, null, renderDom),
        href && (React.createElement(StyledSvg, null,
            React.createElement("svg", { role: "img" },
                !!desc && React.createElement("title", null, desc),
                React.createElement("use", { xlinkHref: href, href: href }))))));
}));
var RcIcon = styled(withDeprecatedCheck(_RcIcon, [
    {
        prop: 'icon',
        time: '2021-1',
        comment: 'please use symbol to replace icon',
    },
    {
        prop: 'children',
        time: '2021-1',
        comment: 'please use symbol to replace children',
    },
    {
        prop: 'iconSize',
        time: '2021-1',
        comment: 'please use size',
    },
    {
        prop: 'iconColor',
        time: '2021-1',
        comment: 'please use color',
    },
    {
        prop: 'useLoading',
        time: '2021-1',
        comment: 'please use loading',
    },
    {
        prop: 'loadingSize',
        time: '2021-1',
        comment: 'please use CircularProgressProps={{ size: 24 }} to set custom loading size',
    },
    {
        prop: 'desc',
        time: '2021-1',
        comment: 'please use symbol',
    },
], 'RcIcon'))(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), IconStyle);
RcIcon.defaultProps = {
    size: 'large',
};
RcIcon.displayName = 'RcIcon';
export { RcIcon };
var templateObject_1;
